import React from 'react';
import { useEffect, useRef, useState } from 'react';
import styles from './MultilineSeachInputControl.module.scss';
import { SearchIcon } from '../internal/icons/SearchIcon';
import classNames from 'classnames';

export interface MultilineSearchInputControlProps {
    query?: string;
    onQueryUpdate?: (query: string) => void;
    onSubmit: (query: string) => void;
    extKey: number;
    rows?: number;
    placeholder?: string;
}

export const MultilineSearchInputControl = ({
    placeholder = 'What is happening this weekend?',
    rows = 5,
    ...props
}: MultilineSearchInputControlProps) => {
    const [query, setQuery] = useState(props.query || '');
    const inputRef = useRef<HTMLTextAreaElement | null>(null);
    const [extKey, setExtKey] = useState(props.extKey);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    useEffect(() => {
        if (props.extKey !== extKey) {
            inputRef.current?.focus();
            setExtKey(props.extKey);
        }
    }, [inputRef, extKey, props.extKey]);

    useEffect(() => {
        setQuery(props.query || '');
    }, [props.query]);

    useEffect(() => {
        // Only focus the input on initial load if the input is not already focused
        if (isInitialLoad && inputRef.current) {
            inputRef.current?.focus();
            setIsInitialLoad(false);
        }
    }, [inputRef, isInitialLoad, setIsInitialLoad]);

    return (
        <div className={styles.inputContainer}>
            <div className={styles.input}>
                <div className={styles.textInput}>
                    <textarea
                        ref={inputRef}
                        className={styles.inputControl}
                        placeholder={placeholder}
                        value={query}
                        rows={rows}
                        onKeyUp={(e) => {
                            if (e.key === 'Enter') {
                                props.onSubmit(query);
                            }
                        }}
                        onChange={(event) => {
                            const changedValue = event.target.value;
                            if (!changedValue.endsWith('\n')) {
                                setQuery(changedValue);
                                props.onQueryUpdate?.(changedValue);
                            }
                        }}
                    ></textarea>
                </div>
            </div>
            <div
                className={classNames(styles.searchIcon, {
                    [styles.searchIconEnabled!]: query.length > 0,
                })}
                onClick={() => {
                    props.onSubmit(query);
                }}
            >
                <SearchIcon fill={'white'} />
            </div>
        </div>
    );
};
